import script from "./expend.vue?vue&type=script&setup=true&lang=js"
export * from "./expend.vue?vue&type=script&setup=true&lang=js"

import "./expend.vue?vue&type=style&index=0&id=21831fae&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21831fae"]])

export default __exports__